import * as React from "react";

import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import { TBreadcrumbItem } from "../../../type/common";
import ClientMypageMainEmailForm from "./email_update/client_mypage_main_email_form";

interface IProps {
  isLoading: boolean;
  handleUpdateEmailSubmit: (values: any) => void;
}

const ClientMyPageEmailUpdateComponent: React.FC<IProps> = (props) => {
  const { isLoading, handleUpdateEmailSubmit } = props;

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    routeConfig.clientMypage,
    routeConfig.clientMypageEmailUpdate,
  ];

  return (
    <React.Fragment>
      {isLoading && <Progress canAnimation={false} />}

      <PageWrapper>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <Breadcrumbs breadcrumbItems={breadcrumbItems} />
          <ClientMypageMainEmailForm
            onSubmit={handleUpdateEmailSubmit}
            enableReinitialize={true}
          />
        </div>
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientMyPageEmailUpdateComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/client_mypage_email_update.tsx